/**
 * @desc 分页查询
 */
import {
  PageMemberGroupEntity,
  MemberGroupPageQuery
} from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryPageMemberGroupParameter = MemberGroupPageQuery

const method = 'GET'
const url = '/auth/group/page'

export const queryPageMemberGroupApi = (
  params?: QueryPageMemberGroupParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PageMemberGroupEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryPageMemberGroupApi.method = method
queryPageMemberGroupApi.url = url
